import React from 'react';

interface TypingIndicatorProps {
  label?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ label }) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center space-x-1">
        <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce-1"></span>
        <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce-2"></span>
        <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce-3"></span>
      </div>
      {label ? <span className="text-sm text-muted-foreground">{label}</span> : null}
    </div>
  );
};

export default TypingIndicator;